
import { RRule } from 'rrule';
import { Activity } from 'app/shared/models/action.models';
import { IdName } from 'app/shared/models/standard.models';
import { format, parseISO } from 'date-fns';

export class DateUtilities {
    /**
     * Settings for npx-bootstrap date picker
     */
    static bsConfig = {
        dateInputFormat: 'DD-MM-YYYY', 
        showWeekNumbers: true, 
        isAnimated: true, 
        containerClass: 'theme-default',
        triggers: 'click'
    };

    static mergeDateAndTime(dueDate: Date, dueTime: string): Date {
        const timeParts = dueTime.split(':').map(part => parseInt(part, 10));
        // Assuming dueTime is in the format "HH:mm"
        const hours = timeParts[0];
        const minutes = timeParts[1];
        
        // Create a new Date object to avoid mutating the original dueDate
        const mergedDateTime = new Date(dueDate.getTime());
        mergedDateTime.setHours(hours, minutes, 0, 0); // sets hours, minutes, seconds, and milliseconds
        
        return mergedDateTime;
    }
    
    monthStartFromDate(date: Date){
        return new Date(date.getFullYear(), date.getMonth(), 1)
    }

    monthEndFromDate(date: Date){
        return new Date(date.getFullYear(), date.getMonth() + 1, 0, 23,59,59)
    }

    weekStartFromDate(date:Date){
        return new Date(date.getFullYear(), date.getMonth(), date.getDate() - date.getDay() + 1)
    }

    weekEndFromDate(date:Date){
        return new Date(date.getFullYear(), date.getMonth(), date.getDate() + ( 7 - date.getDay() ))
    }

    monthEndFromDateWithSundayOffset(date:Date){
        let a = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23,59,59)
        if(a.getDay() == 0) { return a }
        else { return new Date(date.getFullYear(), date.getMonth() + 1, 6 - a.getDay(), 23,59,59) }
    }

    rRuleFromDayOffset(days:number, start: Date, end:Date){
        let rr = new RRule(
            {
                freq: RRule.WEEKLY,
                dtstart:start,
                until: end
            }
        )
        return rr.all();
    }

    rRule(ruleString: string, start: Date, end:Date){
        let rr = RRule.fromString(ruleString);
        rr.between(start,end)
    }
    
    rRuleToText(ruleString:string){
        let rr = RRule.fromString(ruleString);
        return rr.toText()
    }

    isLastMinute( date:Date ){ return date.getHours() == 23 && date.getMinutes() == 59; }

    rRuleCount(ruleString:string){
        let a = RRule.fromString(ruleString);
        if(!!a.options.count && a.options.count == 0) return null
        a.options.count = !a.options.count ? null : a.options.count - 1;
        a.origOptions.count = !a.origOptions.count ? null : a.origOptions.count - 1;
        return a.toString();
    }

    isSameDate(a:Date,b:Date){
        return a.getFullYear() == b.getFullYear() && a.getMonth() == b.getMonth() && a.getDate() == b.getDate()
    }

    frequencyToString(freq: number) {
        switch(freq){
          case(0):{ return 'yearly'}
          case(1):{ return 'monthly'}
          case(2):{ return 'weekly'}
          case(3):{ return 'daily' }
          case(4):{ return 'hourly' }
          case(5):{ return 'minutely' }
          case(6):{ return 'secondly' }
        }
      }

    getDayName(date:string, language:string){
        return Intl.DateTimeFormat(language,{weekday:'long'}).format(new Date(date))
    }

    getMonthName(date:string, language:string){
        return Intl.DateTimeFormat(language,{month:'long'}).format(new Date(date))
    }

    getNextDateInRule(rule:string, date:Date){
        if(!rule) return new Date();
        let compareDate = new Date() > date ? new Date() : date;
        let a = RRule.fromString(rule);
        if(a.options.freq == 3) {
            a.options.bymonthday = null; 
            a.origOptions.byweekday = null;
            a.options.byweekday = null;
          };
        a.options.dtstart = date;
        a.options.count = 10;
        let newArray = a.all().filter(x => x > compareDate && !this.isSameDate(x,date));
        if(newArray.length == 0) { return new Date() }
        return newArray[0];
    }

    nextDateInRule(rrule:string, date:Date){
        const rule = RRule.fromString(rrule);
        const next = rule.after(date);
        return next;
    }
    
    dateAfterDate(a:Date,b:Date):boolean{
        return new Date(a.getFullYear(),a.getMonth(),a.getDate()) > new Date(b.getFullYear(),b.getMonth(),b.getDate())
    }

    updateRule(rule:string, date:Date){
        if(!rule) return null;
        let a = RRule.fromString(rule);
        let b = RRule.fromString(rule);
        b.options.dtstart = date;
        if(b.options.interval == 1 && !!b.options.bymonthday && b.options.bymonthday[0] != date.getDate() ) b.options.bymonthday = [date.getDate()];
        let compareDate = new Date() > date ? new Date() : date;
        if(a.options.count) {
            b.options.count = a.options.count + 1;
            a.options.dtstart = date;
            a.origOptions.dtstart = date;
            a.options.until = a.all().reverse()[0];
            a.origOptions.until = a.options.until;
            a.options.count = null;
            a.origOptions.count = null;
            if(!a.options.until) return null
            return a.toString()
        }
        else if(!!a.options.until && new Date() > a.options.until) return null
        else {
            // update the start date in the rule
            b.options.count = 10;
            a.options.dtstart = b.all().filter(x => x > compareDate)[0];
            a.origOptions.dtstart = a.options.dtstart;
            return a.toString()
        }
    }

}
